<template lang="pug">
  .relationship-block(:class="rootClass")
    .header
      lei-popover.header-info
        label.title {{title}}
    .content
      slot
</template>
<script>
import LeiPopover from '../../lei-components/LeiPopover'

export default {
  components: {
    LeiPopover,
  },
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Object,
      default: () => {
      },
    },
  },
  data () {
    return {
      revoked: 'Credential Revoked',
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .relationship-block
    background-color $default-color-light-2
    .header
      color $default-color-bold
      font-weight 600
      display flex
      align-items center
      height 40px
      padding 20px
      background-color $default-color-light-1
      @media (max-width: $mobile-l)
        height auto
        padding 10px 20px

    .content
      padding 30px 20px

    .status
      align-items: center
      display: flex
      margin-left: 5px
      text-align: center
      max-width: 600px
      position: relative


    .first-icon
      color: $danger-color
      margin-left 15px


    .second-icon
      color: $danger-color
      margin-left 15px


    .third-icon
      color: $primary-color-light-5
      margin-left 15px


    .header-info
      display flex
      justify-content space-between
      width 100%
      @media (max-width: $mobile-l)
        align-items flex-start

    .title
      @media (max-width: $mobile)
        width 20%



    .statuses
      display flex
      justify-content space-between
      @media (max-width: $mobile-l)
        flex-direction column


    .lei-popover-icon
      margin-right -5px

</style>



// WEBPACK FOOTER //
// src/components/record-details/credentials/CredentialBlock.vue